export default __webpack_public_path__ + "41a3e7bf827718a8b4f5d1b97060fa05.svg";